import { useNavigate } from 'react-router-dom'
import { TypeNavKey } from 'Type'

const HookNavRedirect = (key :TypeNavKey) :() => void => {
    const navigate = useNavigate()
    return () => navigate(key, {replace: true})
}

export default HookNavRedirect